export const GET_FAQPAGE_BY_ID_METHOD = (id: any, preview: boolean) => `
  query {
    faq(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      slug
      seo {
        title
        description
        keywords
        canonicalUrl
      }
      question
      answer {
        json
        links {
          entries {
            hyperlink {
              ... on Page {
                sys {
                  id
                }
                slug
                content {
                  __typename
                }
              }
              ... on FileBlock {
                sys {
                  id
                }
                imageVaultFile
                metaData
                __typename
              }
            }
          }
        }
      }
      tagName
      audienceCollection {
        items {
          __typename
          sys {
            id
          }
          audianceId
        }
      }
      contentAreaCollection {
        items {
          ... on Link {
            variant
            name
            linkText
            url
            globalLinkItem
            newTab
            ikon
            audienceCollection {
              items {
                sys {
                  id
                }
                audianceId
              }
            }
            reference {
              ... on Page {
                slug
                content {
                  __typename
                }
              }
            }
          }
          ... on Videoblock {
            heading
            url
            text
            linkText
            externalLink
            useButtonLink
            backgroundColor
            audienceCollection{
              items{
                  __typename
                  sys{id}
                  audianceId
                }
            }
            linkToPage {
              content {
                __typename
              }
              slug
            }
            isColumn
            isReverse
          }
          ... on ImageBlock {
            name
            ivImage
            imageDescription
            link {
              globalLinkItem
              reference {
                ...on Page {
                  content {
                    __typename
                  }
                  slug
                }
                ...on FileBlock
                {
                  imageVaultFile
                }
              }
              url
              newTab
            }
            enableZoom
            shareImage
            squareImage
            shareHeading
            shareLinkText
            shareRichtext
            audienceCollection{
              items{
                  __typename
                  sys{id}
                  audianceId
                }
            }
          }
        }
      }
      relatedContentArea {
        sys {
          id
        }
        categories
        name
        heading
        text {
          json
          links {
            entries {
              hyperlink {
                ... on Page {
                  sys {
                    id
                  }
                  slug
                  content {
                    __typename
                  }
                }
              }
            }
          }
        }
        numberOfItems
        sortBy
        includeDynamicFaqs
        linkOnFaqList {
          linkText
          globalLinkItem
          reference {
            ... on Page {
              content {
                __typename
              }
              slug
            }
            ... on FileBlock {
              imageVaultFile
            }
          }
          url
        }
        manualPostsCollection {
          items {
            question
            answer {
              json
            }
          }
        }
        audienceCollection {
          items {
            __typename
            sys {
              id
            }
            audianceId
          }
        }
      }
    }
  }
`;
